export const invoicesList = () => {
  return {
    status: 200,
    data: [
      {
        createdDateTime: '2025-11-23T00:00:00.000+00:00',
        issueDateTime: '2025-01-15T00:00:00.000+00:00',
        invoiceTypeEnum: 'STANDARD_TAX',
        invoiceTypeTransaction: '01',
        invoiceNumber: 'SME00001',
        buyerName: 'XYZ Corp',
        buyerVatNumber: '220007019800002',
        currency: null,
        totalExcludingVat: 100.0,
        vatTotalAmount: 5.0,
        grossTotalIncludingVat: 105.0,
        invoiceStatus: 'ACCEPTED',
      },
      {
        createdDateTime: '2025-11-23T00:00:00.000+00:00',
        issueDateTime: '2025-01-15T00:00:00.000+00:00',
        invoiceTypeEnum: 'STANDARD_TAX',
        invoiceTypeTransaction: '01',
        invoiceNumber: 'SME00002',
        buyerName: 'XYZ Corp',
        buyerVatNumber: '220007019800002',
        currency: null,
        totalExcludingVat: 100.0,
        vatTotalAmount: 5.0,
        grossTotalIncludingVat: 105.0,
        invoiceStatus: 'ACCEPTED',
      },
      {
        createdDateTime: '2025-11-23T00:00:00.000+00:00',
        issueDateTime: '2025-01-15T00:00:00.000+00:00',
        invoiceTypeEnum: 'STANDARD_TAX',
        invoiceTypeTransaction: '01',
        invoiceNumber: 'SME00003',
        buyerName: 'XYZ Corp',
        buyerVatNumber: '220007019800002',
        currency: null,
        totalExcludingVat: 100.0,
        vatTotalAmount: 5.0,
        grossTotalIncludingVat: 105.0,
        invoiceStatus: 'ACCEPTED',
      },
      {
        createdDateTime: '2025-11-23T00:00:00.000+00:00',
        issueDateTime: '2025-01-15T00:00:00.000+00:00',
        invoiceTypeEnum: 'STANDARD_TAX',
        invoiceTypeTransaction: '01',
        invoiceNumber: 'SME00004',
        buyerName: 'XYZ Corp',
        buyerVatNumber: '220007019800002',
        currency: null,
        totalExcludingVat: 100.0,
        vatTotalAmount: 5.0,
        grossTotalIncludingVat: 105.0,
        invoiceStatus: 'IN_DRAFT',
      },
      {
        createdDateTime: '2025-11-23T00:00:00.000+00:00',
        issueDateTime: '2025-01-15T00:00:00.000+00:00',
        invoiceTypeEnum: 'STANDARD_TAX',
        invoiceTypeTransaction: '01',
        invoiceNumber: 'SME00005',
        buyerName: 'XYZ Corp',
        buyerVatNumber: '220007019800002',
        currency: null,
        totalExcludingVat: 100.0,
        vatTotalAmount: 5.0,
        grossTotalIncludingVat: 105.0,
        invoiceStatus: 'IN_DRAFT',
      },
    ],
  };
};

export const invoiceById = () => {
  return {
    status: 200,
    data: {
      buyer: {
        buyerEnglishName: 'Mohammad Barghash',
        buyerArabicName: 'Mohammad Barghash',
        buyerVatNumber: '220007019800002',
        buyerGroupVatNumber: null,
        additionalBuyerIdType: 'CRN',
        additionalBuyerId: 'sadas',
        buyerStreetEn: 'qweqweq',
        buyerStreetAr: 'qweqweq',
        buyerCity: 'asdasd',
        buyerCountryCode: 'AI',
        buyerFlatNumber: 'adasdasd',
        buyerBuildingName: 'sadasd',
        buyerBlock: 'asd',
      },
      seller: {
        vatNumber: '220003381500002',
        groupVatNumber: null,
        sellerEnglishName: 'SAS8',
        sellerArabicName: 'SAS8',
        additionalSellerIdType: 'IGA',
        additionalSellerId: '123234',
        sellerStreetEn: 'hala street',
        sellerStreetAr: 'hala street',
        sellerBlock: 'block 312',
        sellerBuildingName: '312',
        sellerFlatNumber: '121',
        sellerCity: 'HIDD',
        sellerCountryCode: 'AR',
      },
      paymentTerms: {
        paymentMethodCode: 'CASH',
        bankNameEn: null,
        bankNameAr: null,
        accountNumber: null,
        paymentTermsEn: '123',
        paymentTermsAr: '123',
        accountName: null,
      },
      invoiceReferenceNumber: 'SME00034',
      invoiceUniqueIdentifier: 'fb9dc882-69ec-49a2-9852-dbfce4217eb8',
      originalInvoiceReference: '',
      vatNumber: '220003381500002',
      noteType: 'CREDIT_NOTE',
      invoiceIssueDate: '2026-02-15T09:00:00.000+00:00',
      createdDate: '2026-03-03T10:18:23.313+00:00',
      invoiceType: 'STANDARD_TAX',
      purchaseOrderNumber: '123',
      contactNumber: '',
      deemedInvoiceTransaction: false,
      exportsInvoiceTransaction: false,
      summaryInvoiceTransaction: false,
      thirdPartyInvoiceTransaction: false,
      selfBilledInvoiceTransaction: false,
      importOfService: false,
      supplyDate: null,
      paymentDate: null,
      totalAmountExcludingVat: 144,
      totalDiscountsAmount: 0,
      totalVatAmount: 12.4,
      totalIncludingVat: 136.4,
      grossTotalIncludingVat: 136.4,
      totalPayableAmount: 136.4,
      specialTaxTreatmentAr: '',
      specialTaxTreatmentEn: '',
      currency: 'BHD',
      arNotes: null,
      enNotes: 'asdsadasdasasas',
      generateQRCode: true,
      qrCode:
        'AQtTQVM4IHwgU0FTOAIPMjIwMDAzMzgxNTAwMDAyAxMyMDI2LTAyLTE1VDEyOjAwOjAwBAYxMzYuNDAFBDEyLjQGLFZyenE5ZEd0UitBZFRLTkxVMkYwOUlCaTI1eitycWhYZW5VQ1VQQVdnR1U9B2BNRVVDSVFDcG1XMWxNWTZ6MVZ0TThnNnM0cDFlQjk0SFJwSzhCSUYvUThpd2c1andnUUlnUmpqak1aTE5ld3JVT3ZhK0JqZHY2cWtzMTFmM0VTTXdaWTM5SE9KWHNDcz0IWzBZMBMGByqGSM49AgEGCCqGSM49AwEHA0IABGr672Dzd1H846yXo8EzGceTuXU7ywOQbVBrGUN7EGbXf4KiIcT8INLJCswiSXoG8dhR2cSgkIY4A20YN5+cP9M=',
      xmlFile:
        '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',
      pdfWithXMLAttached:
        'https://einvoicing-nonprod-internal-1.s3.me-south-1.amazonaws.com/pdfs/2a6a5237-ca21-454a-8426-98a7f0ea124a.pdf',
      invoiceSubmitError: null,
      reasonOfNote: null,
      invoiceStatus: 'ACCEPTED',
      invoiceTypeTransaction: '0100000000',
      invoiceHash: 'Vrzq9dGtR+AdTKNLU2F09IBi25z+rqhXenUCUPAWgGU=',
      invoiceItems: [
        {
          descriptionAr: '123',
          descriptionEn: '123',
          unitPrice: 12,
          quantity: 12,
          subtotalAmount: 144,
          discountAmount: 0,
          discountPercentage: 0,
          vatRate: 10,
          vatAmount: 14.4,
          totalAmount: 158.4,
          vatRateType: 'S',
          uuid: null,
          taxExemptionReason: null,
        },
      ],
      logoImage: '',
      salesOrderNumber: '123',
      precedingInvoiceIssueDate: null,
      invoicingPeriodStartDate: null,
      invoicingPeriodEndDate: null,
      prepayment: null,
      thirdParty: {
        thirdPartyVatNumber: null,
        thirdPartyTinNumber: null,
        thirdPartyEnglishName: null,
        thirdPartyStreetName: null,
        thirdPartyBlock: null,
        thirdPartyBuildingName: null,
        thirdPartyFlatNumber: null,
        thirdPartyCity: null,
        thirdPartyCountry: null,
      },
      invoiceLevelDiscount: [
        {
          discountAmount: 10,
          amountSubjectToDiscount: null,
          rate: null,
          discountVatRate: 10,
          discountVatRateType: 'S',
          taxExemptionReason: null,
        },
        {
          discountAmount: 10,
          amountSubjectToDiscount: null,
          rate: null,
          discountVatRate: 10,
          discountVatRateType: 'S',
          taxExemptionReason: null,
        },
      ],
      exchangeRate: null,
    },
  };
};

export const registeredSolution = () => {
  return {
    status: 200,
    data: {
      productionCertificateResponseList: [
        {
          commonName: 'TST-886431145-300000017900003',
          solutionSerialNumber:
            '1-TST|2-TST|3-ed22f1d8-e6a2-1118-9b58-d9a8f11e445f',
          vatNumber: '300000017900003',
          organizationUnitName: 'Riyadh Branch',
          organizationName: 'Maximum Speed Tech Supply LTD',
          countryName: 'SA',
          location: 'RRRD2929',
          industry: 'Supply activities',
          requestId: 17462219271708,
          status: 'ACTIVE',
          onBoardingDate: '2025-05-03T00:38:47.179',
          certifiedExpiryDate: '2026-05-03T00:38:47',
          revocationDate: null,
          smecertificate: false,
          subCr: '-',
          invoiceType: '10000',
        },
        {
          commonName: 'TST-886431145-300000017900003',
          solutionSerialNumber: 'Test Serial Number',
          vatNumber: '300000017900003',
          organizationUnitName: 'Riyadh Branch',
          organizationName: 'Maximum Speed Tech Supply LTD',
          countryName: 'SA',
          location: 'RRRD2929',
          industry: 'Supply activities',
          requestId: 17462219271666,
          status: 'ACTIVE',
          onBoardingDate: '2025-02-02T00:38:47.179',
          certifiedExpiryDate: '2026-05-30T00:38:47',
          revocationDate: null,
          smecertificate: false,
          subCr: '-',
          invoiceType: '11000',
        },
        {
          commonName: 'TST-886431145-30000001790000',
          solutionSerialNumber: 'Test Serial Number 2',
          vatNumber: '300000017900003',
          organizationUnitName: 'Riyadh Branch',
          organizationName: 'Maximum Speed Tech Supply LTD',
          countryName: 'SA',
          location: 'RRRD2929',
          industry: 'Supply activities',
          requestId: 17462219271666,
          status: 'ACTIVE',
          onBoardingDate: '2025-02-02T00:38:47.179',
          certifiedExpiryDate: '2026-05-30T00:38:47',
          revocationDate: null,
          smecertificate: false,
          subCr: '-',
          invoiceType: '01000',
        },
        {
          commonName: 'TST-886431145-30000001790000',
          solutionSerialNumber: 'Test Serial Number 4',
          vatNumber: '300000017900003',
          organizationUnitName: 'Riyadh Branch',
          organizationName: 'Maximum Speed Tech Supply LTD',
          countryName: 'SA',
          location: 'RRRD2929',
          industry: 'Supply activities',
          requestId: 17462219271666,
          status: 'REVOKED',
          onBoardingDate: '2025-02-02T00:38:47.179',
          certifiedExpiryDate: '2026-05-30T00:38:47',
          revocationDate: null,
          smecertificate: false,
          subCr: '-',
          invoiceType: '01000',
        },
      ],
    },
  };
};

export const technicalFailures = () => {
  return {
    status: 200,
    data: [
      {
        failureReferenceNumber: 'FM00005',
        vatPayerNumber: '220003372600002',
        technicalFailureType: 'FAILURE_TO_SUBMIT_INVOICES_INTERNET_ERROR',
        technicalFailureDescription: 'test',
        solutionProviderName: 'test',
        technicalFailureDate: '2026-05-19',
        technicalFailureTime: '08:00 - 12:00',
        expectedResolutionDate: '2026-05-21',
        supportingDocuments: false,
        status: 'RESOLVED',
        failureYear: '2026',
        failureMonth: '05',
        documents: [],
        resolution: {
          resolutionDate: '2026-05-19',
          resolutionTime: '04:00 - 08:00',
          additionalInformation: 'asd',
          documents: [
            {
              fileName: 'Door Code Confidentiality.pdf',
              fileType: 'application/pdf',
              fileSize: 217908,
              filePath:
                'https://e-invoice-stg-internal-1.s3.eu-west-1.amazonaws.com/failureNotificationResolution/null/2026-05-19T12%3A40%3A48.743493604-Door%20Code%20Confidentiality.pdf-?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEAoaCWV1LXdlc3QtMSJHMEUCIQD%2FYxCiXKB7JtxIotuPdrFMKHekJtbctHnI%2Bf9gZT7ekQIgHm2eHwCYr7nRgLVsTdGqxzsABEau%2FtBXSiJ%2B%2BKnSa1sqjwUI0v%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw4MjU3NjU0MDQ0MDUiDL3BdTWcER3oWlU1JCrjBM%2BkEQIXuIoQIF8f8y4FFga%2BgBjbwFd%2F0uLIiONKlhO35mlUc%2FqlFn1%2BAIXPS4suE8SOnVkt1IlcTh0xUsOAJRXXYiOxyjKRN9E6XLgw3l%2F8tuSXyJn8X1uyW8MdaybIRasfD9EEKJ27BI883Vmw62UYYMQKQOQhGVU%2BVnBAqg3Lk9gw1TzhSh3868o5Rexcn0XgxDmNCm9DjUWWDQG7IkazkrnQWKVOZB5osZCR3YnJijJGA9ikOUWva3gKbBZrKE%2FLHkW%2BZGMh9F39WW10JSer2VuCZjifW4Gg0IukCuVGeVAbgP9A3ahXazlSSiavAkgI3lq97LuaYL2Yi8J5PfcQmO9hnFes3hL32N0TOACQfvX2Am17CFolKdMsWp4cB7MZNjLM9lC%2BwwfmMoYyk%2BudNi1XtTrQOd2NNduFbar%2BhJYEa%2Fq6ql%2BXSs18dID5gpbr%2FrgdGLNu3INd%2B4A81zGB6zxdR9s9xzoQQKId%2BCff7CUhnAAMD9AjYsQAkII5gPVu6eaAWjJdhwnp%2FFy8BWTY4YJUPHcD9u%2FJeUzg1QvFn3vKLgPWTHlnh76bngx%2BRuTHAPj4RUzRYaNJyp%2BVmpBCRcEt7lwBddokbF4L%2BdgFpI9XeMSGQRZwg9BCgxQjy3qQn68lhPzfKIQW%2BjEQxNFHN%2FWtfv%2FVNCKdxD9EbrgeHGSp5KJM9GsoyPpU00566mpqgH8knck5GXX2tfwWgnqsDrJf%2BOee%2BUbrLUUybo9jBOVMm3ckft8aXLvDMd0R7AFK9hKGfF9RAKV3LtZemFkujcL7af6YqJwteo%2B4aeI6Bu0UMMPWsNAGOpgBvmEjVyM078j3tDLUqA86Z%2B5%2BM1e6mu%2FYbCETzmXxjgFQXEhKD3OOJ1AkM2pDVRJkX4L78N8t5Pk6i77OBsFoLtLpfTTGYZhi9WdQG954MG2tBXZeAQqtObfXsC1UXeJ7tAnTYdBB8A0J56zpugMOd%2FxWJgIWCtjLP2%2BmDPKarThB2yh8Bs%2BbL9ediIgY2MQi%2BWFdRqxB6hQ%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20260519T101426Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIA4AQ3UD32VJK445AL%2F20260519%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Expires=86400&X-Amz-Signature=9ddfa537d52902c04f5c6246f13d275da28a291329fb613aa2846ca557657b32',
            },
          ],
        },
      },
      {
        failureReferenceNumber: 'FM00006',
        vatPayerNumber: '220003372600002',
        technicalFailureType: 'FAILURE_TO_SUBMIT_INVOICES_INTERNET_ERROR',
        technicalFailureDescription: 'test',
        solutionProviderName: 'John',
        technicalFailureDate: '2026-05-19',
        technicalFailureTime: '04:00 - 08:00',
        expectedResolutionDate: '2026-05-21',
        supportingDocuments: true,
        status: 'RESOLVED',
        failureYear: '2026',
        failureMonth: '05',
        documents: [
          {
            fileName:
              '220003372600002_20100520_72997268-da83-4257-a5c6-bf12affdfba4.pdf',
            fileType: 'application/pdf',
            fileSize: 533222,
            filePath:
              'https://e-invoice-stg-internal-1.s3.eu-west-1.amazonaws.com/failureNotification/2026-05-19T10%3A02%3A31.906109100-220003372600002_20100520_72997268-da83-4257-a5c6-bf12affdfba4.pdf?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEAoaCWV1LXdlc3QtMSJHMEUCIQD%2FYxCiXKB7JtxIotuPdrFMKHekJtbctHnI%2Bf9gZT7ekQIgHm2eHwCYr7nRgLVsTdGqxzsABEau%2FtBXSiJ%2B%2BKnSa1sqjwUI0v%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw4MjU3NjU0MDQ0MDUiDL3BdTWcER3oWlU1JCrjBM%2BkEQIXuIoQIF8f8y4FFga%2BgBjbwFd%2F0uLIiONKlhO35mlUc%2FqlFn1%2BAIXPS4suE8SOnVkt1IlcTh0xUsOAJRXXYiOxyjKRN9E6XLgw3l%2F8tuSXyJn8X1uyW8MdaybIRasfD9EEKJ27BI883Vmw62UYYMQKQOQhGVU%2BVnBAqg3Lk9gw1TzhSh3868o5Rexcn0XgxDmNCm9DjUWWDQG7IkazkrnQWKVOZB5osZCR3YnJijJGA9ikOUWva3gKbBZrKE%2FLHkW%2BZGMh9F39WW10JSer2VuCZjifW4Gg0IukCuVGeVAbgP9A3ahXazlSSiavAkgI3lq97LuaYL2Yi8J5PfcQmO9hnFes3hL32N0TOACQfvX2Am17CFolKdMsWp4cB7MZNjLM9lC%2BwwfmMoYyk%2BudNi1XtTrQOd2NNduFbar%2BhJYEa%2Fq6ql%2BXSs18dID5gpbr%2FrgdGLNu3INd%2B4A81zGB6zxdR9s9xzoQQKId%2BCff7CUhnAAMD9AjYsQAkII5gPVu6eaAWjJdhwnp%2FFy8BWTY4YJUPHcD9u%2FJeUzg1QvFn3vKLgPWTHlnh76bngx%2BRuTHAPj4RUzRYaNJyp%2BVmpBCRcEt7lwBddokbF4L%2BdgFpI9XeMSGQRZwg9BCgxQjy3qQn68lhPzfKIQW%2BjEQxNFHN%2FWtfv%2FVNCKdxD9EbrgeHGSp5KJM9GsoyPpU00566mpqgH8knck5GXX2tfwWgnqsDrJf%2BOee%2BUbrLUUybo9jBOVMm3ckft8aXLvDMd0R7AFK9hKGfF9RAKV3LtZemFkujcL7af6YqJwteo%2B4aeI6Bu0UMMPWsNAGOpgBvmEjVyM078j3tDLUqA86Z%2B5%2BM1e6mu%2FYbCETzmXxjgFQXEhKD3OOJ1AkM2pDVRJkX4L78N8t5Pk6i77OBsFoLtLpfTTGYZhi9WdQG954MG2tBXZeAQqtObfXsC1UXeJ7tAnTYdBB8A0J56zpugMOd%2FxWJgIWCtjLP2%2BmDPKarThB2yh8Bs%2BbL9ediIgY2MQi%2BWFdRqxB6hQ%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20260519T101426Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIA4AQ3UD32VJK445AL%2F20260519%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Expires=86400&X-Amz-Signature=c683e135c4eba25e3f2317391abfd6c4c35663a2604651136f2babeb20414d57',
          },
        ],
        resolution: {
          resolutionDate: '2026-05-19',
          resolutionTime: '04:00 - 08:00',
          additionalInformation: '',
          documents: [],
        },
      },
      {
        failureReferenceNumber: 'FM00007',
        vatPayerNumber: '220003372600002',
        technicalFailureType: 'FAILURE_TO_GENERATE_INVOICES_SOLUTION_ERROR',
        technicalFailureDescription: 'tes',
        solutionProviderName: 'test',
        technicalFailureDate: '2026-05-19',
        technicalFailureTime: '04:00 - 08:00',
        expectedResolutionDate: '2026-05-22',
        supportingDocuments: false,
        status: 'RESOLVED',
        failureYear: '2026',
        failureMonth: '05',
        documents: [],
        resolution: {
          resolutionDate: '2026-05-19',
          resolutionTime: '08:00 - 12:00',
          additionalInformation: '',
          documents: [
            {
              fileName:
                '220003016900002_20260120_0a1f629c-de0e-4f11-badd-277afad3429d (1).pdf',
              fileType: 'application/pdf',
              fileSize: 554107,
              filePath:
                'https://e-invoice-stg-internal-1.s3.eu-west-1.amazonaws.com/failureNotificationResolution/null/2026-05-19T13%3A14%3A09.767700666-220003016900002_20260120_0a1f629c-de0e-4f11-badd-277afad3429d%20%281%29.pdf-?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEAoaCWV1LXdlc3QtMSJHMEUCIQD%2FYxCiXKB7JtxIotuPdrFMKHekJtbctHnI%2Bf9gZT7ekQIgHm2eHwCYr7nRgLVsTdGqxzsABEau%2FtBXSiJ%2B%2BKnSa1sqjwUI0v%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw4MjU3NjU0MDQ0MDUiDL3BdTWcER3oWlU1JCrjBM%2BkEQIXuIoQIF8f8y4FFga%2BgBjbwFd%2F0uLIiONKlhO35mlUc%2FqlFn1%2BAIXPS4suE8SOnVkt1IlcTh0xUsOAJRXXYiOxyjKRN9E6XLgw3l%2F8tuSXyJn8X1uyW8MdaybIRasfD9EEKJ27BI883Vmw62UYYMQKQOQhGVU%2BVnBAqg3Lk9gw1TzhSh3868o5Rexcn0XgxDmNCm9DjUWWDQG7IkazkrnQWKVOZB5osZCR3YnJijJGA9ikOUWva3gKbBZrKE%2FLHkW%2BZGMh9F39WW10JSer2VuCZjifW4Gg0IukCuVGeVAbgP9A3ahXazlSSiavAkgI3lq97LuaYL2Yi8J5PfcQmO9hnFes3hL32N0TOACQfvX2Am17CFolKdMsWp4cB7MZNjLM9lC%2BwwfmMoYyk%2BudNi1XtTrQOd2NNduFbar%2BhJYEa%2Fq6ql%2BXSs18dID5gpbr%2FrgdGLNu3INd%2B4A81zGB6zxdR9s9xzoQQKId%2BCff7CUhnAAMD9AjYsQAkII5gPVu6eaAWjJdhwnp%2FFy8BWTY4YJUPHcD9u%2FJeUzg1QvFn3vKLgPWTHlnh76bngx%2BRuTHAPj4RUzRYaNJyp%2BVmpBCRcEt7lwBddokbF4L%2BdgFpI9XeMSGQRZwg9BCgxQjy3qQn68lhPzfKIQW%2BjEQxNFHN%2FWtfv%2FVNCKdxD9EbrgeHGSp5KJM9GsoyPpU00566mpqgH8knck5GXX2tfwWgnqsDrJf%2BOee%2BUbrLUUybo9jBOVMm3ckft8aXLvDMd0R7AFK9hKGfF9RAKV3LtZemFkujcL7af6YqJwteo%2B4aeI6Bu0UMMPWsNAGOpgBvmEjVyM078j3tDLUqA86Z%2B5%2BM1e6mu%2FYbCETzmXxjgFQXEhKD3OOJ1AkM2pDVRJkX4L78N8t5Pk6i77OBsFoLtLpfTTGYZhi9WdQG954MG2tBXZeAQqtObfXsC1UXeJ7tAnTYdBB8A0J56zpugMOd%2FxWJgIWCtjLP2%2BmDPKarThB2yh8Bs%2BbL9ediIgY2MQi%2BWFdRqxB6hQ%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20260519T101426Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIA4AQ3UD32VJK445AL%2F20260519%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Expires=86400&X-Amz-Signature=5aa4a979910bd6d2c903715627e0c53cb413dd5ecbd3cbeecff7c5a8165773ab',
            },
          ],
        },
      },
      {
        failureReferenceNumber: '6d2b4368-46da-42f3-9177-01ee5b6af51c',
        vatPayerNumber: '220003372600002',
        technicalFailureType: 'FAILURE_TO_SUBMIT_INVOICES_INTEGRATION_ERROR',
        technicalFailureDescription: 'asdad',
        solutionProviderName: 'sadsad',
        technicalFailureDate: '2026-05-17',
        technicalFailureTime: '12:00 - 16:00',
        expectedResolutionDate: '2026-05-20',
        supportingDocuments: false,
        status: 'OPEN',
        failureYear: '2026',
        failureMonth: '05',
        documents: [],
        resolution: null,
      },
      {
        failureReferenceNumber: '7759309f-6ee2-4959-9679-9dcfa7fbfec8',
        vatPayerNumber: '220003372600002',
        technicalFailureType: 'FAILURE_TO_SUBMIT_INVOICES_INTEGRATION_ERROR',
        technicalFailureDescription: 'asdasdasd',
        solutionProviderName: 'asasdas',
        technicalFailureDate: '2026-05-17',
        technicalFailureTime: '04:00 - 08:00',
        expectedResolutionDate: '2026-05-17',
        supportingDocuments: true,
        status: 'OPEN',
        failureYear: '2026',
        failureMonth: '05',
        documents: [
          {
            fileName: 'MicrosoftTeams-image-fa8IGeJwM-transformed.jpeg',
            fileType: 'image/jpeg',
            fileSize: 799800,
            filePath:
              'https://e-invoice-stg-internal-1.s3.eu-west-1.amazonaws.com/failureNotification/2026-05-17T14%3A16%3A39.808391468-MicrosoftTeams-image-fa8IGeJwM-transformed.jpeg?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEAoaCWV1LXdlc3QtMSJHMEUCIQD%2FYxCiXKB7JtxIotuPdrFMKHekJtbctHnI%2Bf9gZT7ekQIgHm2eHwCYr7nRgLVsTdGqxzsABEau%2FtBXSiJ%2B%2BKnSa1sqjwUI0v%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw4MjU3NjU0MDQ0MDUiDL3BdTWcER3oWlU1JCrjBM%2BkEQIXuIoQIF8f8y4FFga%2BgBjbwFd%2F0uLIiONKlhO35mlUc%2FqlFn1%2BAIXPS4suE8SOnVkt1IlcTh0xUsOAJRXXYiOxyjKRN9E6XLgw3l%2F8tuSXyJn8X1uyW8MdaybIRasfD9EEKJ27BI883Vmw62UYYMQKQOQhGVU%2BVnBAqg3Lk9gw1TzhSh3868o5Rexcn0XgxDmNCm9DjUWWDQG7IkazkrnQWKVOZB5osZCR3YnJijJGA9ikOUWva3gKbBZrKE%2FLHkW%2BZGMh9F39WW10JSer2VuCZjifW4Gg0IukCuVGeVAbgP9A3ahXazlSSiavAkgI3lq97LuaYL2Yi8J5PfcQmO9hnFes3hL32N0TOACQfvX2Am17CFolKdMsWp4cB7MZNjLM9lC%2BwwfmMoYyk%2BudNi1XtTrQOd2NNduFbar%2BhJYEa%2Fq6ql%2BXSs18dID5gpbr%2FrgdGLNu3INd%2B4A81zGB6zxdR9s9xzoQQKId%2BCff7CUhnAAMD9AjYsQAkII5gPVu6eaAWjJdhwnp%2FFy8BWTY4YJUPHcD9u%2FJeUzg1QvFn3vKLgPWTHlnh76bngx%2BRuTHAPj4RUzRYaNJyp%2BVmpBCRcEt7lwBddokbF4L%2BdgFpI9XeMSGQRZwg9BCgxQjy3qQn68lhPzfKIQW%2BjEQxNFHN%2FWtfv%2FVNCKdxD9EbrgeHGSp5KJM9GsoyPpU00566mpqgH8knck5GXX2tfwWgnqsDrJf%2BOee%2BUbrLUUybo9jBOVMm3ckft8aXLvDMd0R7AFK9hKGfF9RAKV3LtZemFkujcL7af6YqJwteo%2B4aeI6Bu0UMMPWsNAGOpgBvmEjVyM078j3tDLUqA86Z%2B5%2BM1e6mu%2FYbCETzmXxjgFQXEhKD3OOJ1AkM2pDVRJkX4L78N8t5Pk6i77OBsFoLtLpfTTGYZhi9WdQG954MG2tBXZeAQqtObfXsC1UXeJ7tAnTYdBB8A0J56zpugMOd%2FxWJgIWCtjLP2%2BmDPKarThB2yh8Bs%2BbL9ediIgY2MQi%2BWFdRqxB6hQ%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20260519T101426Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIA4AQ3UD32VJK445AL%2F20260519%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Expires=86400&X-Amz-Signature=3c0bade57062f16857e5b7ed3de642efb9c034f9457fa0492954b77af4fa6b15',
          },
        ],
        resolution: null,
      },
      {
        failureReferenceNumber: '9dd21581-ce69-4a7e-b2f7-98ec67ba68c7',
        vatPayerNumber: '220003372600002',
        technicalFailureType: 'FAILURE_TO_GENERATE_INVOICES_SOLUTION_ERROR',
        technicalFailureDescription: 'Tech 1',
        solutionProviderName: 'Tech 1',
        technicalFailureDate: '2026-05-17',
        technicalFailureTime: '00:00 - 04:00',
        expectedResolutionDate: '2026-05-19',
        supportingDocuments: false,
        status: 'OPEN',
        failureYear: '2026',
        failureMonth: '05',
        documents: [],
        resolution: null,
      },
      {
        failureReferenceNumber: 'b54e3ac9-0957-4731-82a5-63d23a7d9cb7',
        vatPayerNumber: '220003372600002',
        technicalFailureType: 'FAILURE_TO_GENERATE_INVOICES_SOLUTION_ERROR',
        technicalFailureDescription: 'asd',
        solutionProviderName: 'John',
        technicalFailureDate: '2026-05-10',
        technicalFailureTime: '04:00 - 08:00',
        expectedResolutionDate: '2026-05-11',
        supportingDocuments: false,
        status: 'OPEN',
        failureYear: '2026',
        failureMonth: '05',
        documents: [],
        resolution: null,
      },
      {
        failureReferenceNumber: '8702574e-4682-468b-9028-ef9f2517dd40',
        vatPayerNumber: '220003372600002',
        technicalFailureType: 'FAILURE_TO_SUBMIT_INVOICES_INTERNET_ERROR',
        technicalFailureDescription: '@#$$%',
        solutionProviderName: 'Agile Technologies',
        technicalFailureDate: '2026-05-05',
        technicalFailureTime: '00:00 - 04:00',
        expectedResolutionDate: '2026-05-06',
        supportingDocuments: false,
        status: 'RESOLVED',
        failureYear: '2026',
        failureMonth: '05',
        documents: [],
        resolution: {
          resolutionDate: '2026-05-05',
          resolutionTime: '08:00 - 12:00',
          additionalInformation: 's;dokfj;klgjlkgjadlkfjghalkdfgfhmgjmjhj',
          documents: [],
        },
      },
      {
        failureReferenceNumber: 'eebde649-97a1-436c-83a8-654798ccc819',
        vatPayerNumber: '220003372600002',
        technicalFailureType: 'OTHER',
        technicalFailureDescription:
          "dgf'lkjglkhjlk;hjsdl;kghjdflkgjalskgjl'mhlkhm",
        solutionProviderName: 'Google',
        technicalFailureDate: '2026-05-01',
        technicalFailureTime: '04:00 - 08:00',
        expectedResolutionDate: '2026-05-22',
        supportingDocuments: false,
        status: 'RESOLVED',
        failureYear: '2026',
        failureMonth: '05',
        documents: [],
        resolution: {
          resolutionDate: '2026-05-02',
          resolutionTime: '12:00 - 16:00',
          additionalInformation: 'kpolkj',
          documents: [],
        },
      },
    ],
  };
};

export const certificationCounts = () => ({
  status: 200,
  data: {
    vat: '300000017900003',
    certificateValid: 1,
    certificateRevoked: 2,
    certificateExpired: 2,
  },
});

export const invoicesCounts = () => ({
  status: 200,
  data: {
    clearance: {
      warringInvoicesCount: 10,
      passedInvoicesCount: 50,
      errorInvoicesCount: 20,
    },
    reporting: {
      warringInvoicesCount: 2,
      passedInvoicesCount: 6,
      errorInvoicesCount: 3,
    },
  },
});

const generateOTPs = (num) => {
  const OTPs = new Uint32Array(1);
  window.crypto.getRandomValues(OTPs);
  return String(OTPs[0]).slice(-num).padStart(num, '0');
};

export const OTPs = (num) => ({
  status: 200,
  data: {
    OTPs: [generateOTPs(num)],
  },
});

export const authorization = () => {
  return {
    status: 200,
    data: false,
  };
};

export const specialBillingAgreements = () => {
  return {
    status: 200,
    data: [
      {
        agreementId: 1,
        agreementType: 'SelfBilling',
        buyerId: '220003372600002',
        sellerId: '220003372600002',
        thirdPartyId: null,
        buyerEmail: 'mohammed.barghash99@gmail.com',
        sellerEmail: 'john.monir1@gmail.com',
        thirdPartyEmail: '',
        buyerPhoneNumber: '+97312345678',
        sellerPhoneNumber: '+97112345678',
        thirdPhoneNumber: null,
        buyerName: '220003021200002',
        sellerName: 'TP44',
        thirdPartyName: '',
        status: 'Open',
        reason: 'Pending_Confirmation_Confirm_Party',
        details: 'asdasdasda',
        validUntil: '2026-06-14',
        version: 1,
        createdAt: '2026-06-09T18:30:41.205526',
        createdByUser: 'TP442200033726',
        approvedAt: null,
        approvedByUser: null,
        rejectedReason: null,
        terminatedAt: null,
        terminatedByUser: null,
        terminationReason: null,
        revokedAt: null,
        revokedBy: null,
        revokedReason: null,
        lastUpdatedAt: null,
        referenceNumber: 'SB-1',
        subReferenceNumber: 'SB-1-1',
        startDate: '2026-06-09',
        endDate: '2026-06-09',
        agreementFile:
          'https://e-invoice-dev-internal-1.s3.eu-west-1.amazonaws.com/agreements/220003372600002_20020620_e9866b92-09b5-43be-84c7-99537a5c8a73.pdf',
        agreementFile1: null,
        agreementFile2: null,
      },
      {
        agreementId: 2,
        agreementType: 'SelfBilling',
        buyerId: '220003021200002',
        sellerId: '220003372600002',
        thirdPartyId: null,
        buyerEmail: 'halrashidy@deloitte.com',
        sellerEmail: 'john.monir@gmail.com',
        thirdPartyEmail: '',
        buyerPhoneNumber: '+201002500949',
        sellerPhoneNumber: '+201002500922',
        thirdPhoneNumber: null,
        buyerName: 'ZJ02',
        sellerName: 'TP44',
        thirdPartyName: '',
        status: 'Open',
        reason: 'Pending_Confirmation_Confirm_Party',
        details: 'Test Test',
        validUntil: '2026-06-15',
        version: 1,
        createdAt: '2026-06-10T11:43:05.969328',
        createdByUser: 'TP442200033726',
        approvedAt: null,
        approvedByUser: null,
        rejectedReason: null,
        terminatedAt: null,
        terminatedByUser: null,
        terminationReason: null,
        revokedAt: null,
        revokedBy: null,
        revokedReason: null,
        lastUpdatedAt: null,
        referenceNumber: 'SB-2',
        subReferenceNumber: 'SB-2-1',
        startDate: '2026-06-10',
        endDate: '2026-06-20',
        agreementFile:
          'https://e-invoice-dev-internal-1.s3.eu-west-1.amazonaws.com/agreements/_PDFs_PROD.pdf',
        agreementFile1: null,
        agreementFile2: null,
      },
      {
        agreementId: 3,
        agreementType: 'SelfBilling',
        buyerId: '220003021200002',
        sellerId: '220003372600002',
        thirdPartyId: null,
        buyerEmail: 'halrashidy@deloitte.com',
        sellerEmail: 'john.monir1@gmail.com',
        thirdPartyEmail: '',
        buyerPhoneNumber: '+201002500949',
        sellerPhoneNumber: '+20100250939',
        thirdPhoneNumber: null,
        buyerName: 'Test',
        sellerName: 'TP44',
        thirdPartyName: '',
        status: 'Open',
        reason: 'Pending_Confirmation_Confirm_Party',
        details: 'Test test test',
        validUntil: '2026-06-15',
        version: 1,
        createdAt: '2026-06-10T13:47:01.35511',
        createdByUser: 'TP442200033726',
        approvedAt: null,
        approvedByUser: null,
        rejectedReason: null,
        terminatedAt: null,
        terminatedByUser: null,
        terminationReason: null,
        revokedAt: null,
        revokedBy: null,
        revokedReason: null,
        lastUpdatedAt: null,
        referenceNumber: 'SB-3',
        subReferenceNumber: 'SB-3-1',
        startDate: '2026-06-10',
        endDate: '2026-06-25',
        agreementFile:
          'https://e-invoice-dev-internal-1.s3.eu-west-1.amazonaws.com/agreements/_PDFs_PROD.pdf',
        agreementFile1: null,
        agreementFile2: null,
      },
      {
        agreementId: 4,
        agreementType: 'SelfBilling',
        buyerId: '220003021200002',
        sellerId: '220003372600002',
        thirdPartyId: null,
        buyerEmail: 'halrashidy@deloitte.com',
        sellerEmail: 'john.monir1@gmail.com',
        thirdPartyEmail: '',
        buyerPhoneNumber: '+201002500949',
        sellerPhoneNumber: '+20100250939',
        thirdPhoneNumber: null,
        buyerName: 'Test',
        sellerName: 'TP44',
        thirdPartyName: '',
        status: 'Open',
        reason: 'Draft',
        details: 'Test test test',
        validUntil: '2026-06-15',
        version: 1,
        createdAt: '2026-06-10T13:49:57.453876',
        createdByUser: 'TP442200033726',
        approvedAt: null,
        approvedByUser: null,
        rejectedReason: null,
        terminatedAt: null,
        terminatedByUser: null,
        terminationReason: null,
        revokedAt: null,
        revokedBy: null,
        revokedReason: null,
        lastUpdatedAt: null,
        referenceNumber: 'SB-4',
        subReferenceNumber: 'SB-4-1',
        startDate: '2026-06-10',
        endDate: '2026-06-25',
        agreementFile:
          'https://e-invoice-dev-internal-1.s3.eu-west-1.amazonaws.com/agreements/_PDFs_PROD.pdf',
        agreementFile1: null,
        agreementFile2: null,
      },
      {
        agreementId: 6,
        agreementType: 'SelfBilling',
        buyerId: '220003021200002',
        sellerId: '220003372600002',
        thirdPartyId: null,
        buyerEmail: 'halrashidy@deloitte.com',
        sellerEmail: 'john.monir1@gmail.com',
        thirdPartyEmail: '',
        buyerPhoneNumber: '+201002688987',
        sellerPhoneNumber: '+201004588737',
        thirdPhoneNumber: null,
        buyerName: 'Test',
        sellerName: 'TP44',
        thirdPartyName: '',
        status: 'Open',
        reason: 'Draft',
        details: 'Test test test',
        validUntil: '2026-06-15',
        version: 1,
        createdAt: '2026-06-10T13:51:40.931785',
        createdByUser: 'TP442200033726',
        approvedAt: null,
        approvedByUser: null,
        rejectedReason: null,
        terminatedAt: null,
        terminatedByUser: null,
        terminationReason: null,
        revokedAt: null,
        revokedBy: null,
        revokedReason: null,
        lastUpdatedAt: null,
        referenceNumber: 'SB-6',
        subReferenceNumber: 'SB-6-1',
        startDate: '2026-06-10',
        endDate: '2026-07-30',
        agreementFile: null,
        agreementFile1: null,
        agreementFile2: null,
      },
      {
        agreementId: 7,
        agreementType: 'SelfBilling',
        buyerId: '220003021200002',
        sellerId: '220003372600002',
        thirdPartyId: null,
        buyerEmail: 'maysara.anwar93@gmail.com',
        sellerEmail: 'john.monir1@gmail.com',
        thirdPartyEmail: '',
        buyerPhoneNumber: '+201002500949',
        sellerPhoneNumber: '+201002788727',
        thirdPhoneNumber: null,
        buyerName: 'Test',
        sellerName: 'TP44',
        thirdPartyName: '',
        status: 'Open',
        reason: 'Pending_Confirmation_Confirm_Party',
        details: 'Test test test',
        validUntil: '2026-06-15',
        version: 1,
        createdAt: '2026-06-10T14:51:49.370786',
        createdByUser: 'TP442200033726',
        approvedAt: null,
        approvedByUser: null,
        rejectedReason: null,
        terminatedAt: null,
        terminatedByUser: null,
        terminationReason: null,
        revokedAt: null,
        revokedBy: null,
        revokedReason: null,
        lastUpdatedAt: null,
        referenceNumber: 'SB-7',
        subReferenceNumber: 'SB-7-1',
        startDate: '2026-06-10',
        endDate: '2026-06-30',
        agreementFile:
          'https://e-invoice-dev-internal-1.s3.eu-west-1.amazonaws.com/agreements/_PDFs_PROD.pdf',
        agreementFile1: null,
        agreementFile2: null,
      },
    ],
  };
};

export const terminateSpecialBillingAgreementsMock = () => {
  return {
    status: 200,
    data: {
      message: 'agreements terminated successfully',
    },
  };
};

export const pointsOfContact = () => {
  return {
    status: 200,
    data: [
      {
        contactId: 9,
        taxpayerId: 'EINV1',
        channelSms: true,
        channelMail: true,
        contactValueMail: 'test@xyzcorp.com',
        contactValueSms: '0799999999',
        status: 'PENDING',
        isPrimary: true,
        isSecondary: false,
        isTrmManaged: true,
        createdAt: '2025-11-03T10:44:43.662221Z',
      },
      {
        contactId: 10,
        taxpayerId: 'EINV1',
        channelSms: true,
        channelMail: true,
        contactValueMail: 'contact1@xyzcorp.com',
        contactValueSms: '0799999998',
        status: 'PENDING',
        isPrimary: false,
        isSecondary: true,
        isTrmManaged: true,
        createdAt: '2025-11-03T10:44:43.662243Z',
      },
      {
        contactId: 13,
        taxpayerId: 'EINV1',
        channelSms: false,
        channelMail: true,
        contactValueMail: 'email@gmail.com',
        contactValueSms: '12342',
        status: 'PENDING',
        isPrimary: false,
        isSecondary: false,
        isTrmManaged: false,
        createdAt: '2025-11-06T11:49:04.554710Z',
      },
    ],
  };
};

export const activatePointOfContactMock = (token) => {
  switch (token) {
    case 'success':
      return {
        status: 200,
        data: {
          status: 'ACTIVE',
        },
      };
    case 'already':
      return {
        status: 200,
        data: {
          status: 'ALREADY_ACTIVE',
        },
      };
    default:
      throw new Error('Faield to activate');
  }
};

export const getSpecialAgreementInfoMock = (agreementId) => {
  const d = specialBillingAgreements().data.find(
    (agreement) =>
      agreement.agreementId == agreementId ||
      agreement.referenceNumber == agreementId,
  );

  return d;
};

export const getVatInfoMock = () => ({
  name: 'SAS8',
  phoneNumber: '97387428274',
  email: 'SAS8@TEST.COM',
  strSuppl1: '312',
  city: 'HIDD',
  houseNumber: '121',
  street: 'hala street',
  block: 'block 312',
});

export const invoiceViewSales = () => ({
  status: 200,
  data: [
    {
      vatNumber: '220003021700002',
      numberOfInvoices: 1,
      grossTotalAmount: 105.0,
      vatAmount: 5.0,
      netAmount: 100.0,
      date: '2026-01-20',
    },
    {
      vatNumber: '220007019800002',
      numberOfInvoices: 3,
      grossTotalAmount: 525.0,
      vatAmount: 25.0,
      netAmount: 500.0,
      date: '2026-01-19',
    },
    {
      vatNumber: '220003021700002',
      numberOfInvoices: 2,
      grossTotalAmount: 315.0,
      vatAmount: 15.0,
      netAmount: 300.0,
      date: '2026-01-18',
    },
    {
      vatNumber: '220009012300005',
      numberOfInvoices: 5,
      grossTotalAmount: 1050.0,
      vatAmount: 50.0,
      netAmount: 1000.0,
      date: '2026-01-17',
    },
    {
      vatNumber: '220007019800002',
      numberOfInvoices: 1,
      grossTotalAmount: 210.0,
      vatAmount: 10.0,
      netAmount: 200.0,
      date: '2026-01-16',
    },
    {
      vatNumber: '220003021700002',
      numberOfInvoices: 4,
      grossTotalAmount: 735.0,
      vatAmount: 35.0,
      netAmount: 700.0,
      date: '2026-01-15',
    },
    {
      vatNumber: '220012045600008',
      numberOfInvoices: 2,
      grossTotalAmount: 420.0,
      vatAmount: 20.0,
      netAmount: 400.0,
      date: '2026-01-14',
    },
    {
      vatNumber: '220009012300005',
      numberOfInvoices: 6,
      grossTotalAmount: 1575.0,
      vatAmount: 75.0,
      netAmount: 1500.0,
      date: '2026-01-13',
    },
    {
      vatNumber: '220003021700002',
      numberOfInvoices: 3,
      grossTotalAmount: 262.5,
      vatAmount: 12.5,
      netAmount: 250.0,
      date: '2026-01-12',
    },
    {
      vatNumber: '220007019800002',
      numberOfInvoices: 7,
      grossTotalAmount: 1890.0,
      vatAmount: 90.0,
      netAmount: 1800.0,
      date: '2026-01-11',
    },
    {
      vatNumber: '220012045600008',
      numberOfInvoices: 1,
      grossTotalAmount: 157.5,
      vatAmount: 7.5,
      netAmount: 150.0,
      date: '2026-01-10',
    },
    {
      vatNumber: '220009012300005',
      numberOfInvoices: 4,
      grossTotalAmount: 630.0,
      vatAmount: 30.0,
      netAmount: 600.0,
      date: '2026-01-09',
    },
    {
      vatNumber: '220003021700002',
      numberOfInvoices: 2,
      grossTotalAmount: 367.5,
      vatAmount: 17.5,
      netAmount: 350.0,
      date: '2026-01-08',
    },
    {
      vatNumber: '220015067800011',
      numberOfInvoices: 8,
      grossTotalAmount: 2100.0,
      vatAmount: 100.0,
      netAmount: 2000.0,
      date: '2026-01-07',
    },
    {
      vatNumber: '220007019800002',
      numberOfInvoices: 3,
      grossTotalAmount: 472.5,
      vatAmount: 22.5,
      netAmount: 450.0,
      date: '2026-01-06',
    },
  ],
});

export const invoiceViewSalesCounts = () => ({
  status: 200,
  data: [
    {
      vatNumber: '220003021700002',
      date: '2026-01-20',
      acceptedVat: 5,
      warningVat: 1,
      rejectedVat: 0,
      acceptedSimplified: 3,
      warningSimplified: 0,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220007019800002',
      date: '2026-01-19',
      acceptedVat: 8,
      warningVat: 0,
      rejectedVat: 2,
      acceptedSimplified: 4,
      warningSimplified: 1,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220012045600008',
      date: '2026-01-18',
      acceptedVat: 12,
      warningVat: 2,
      rejectedVat: 1,
      acceptedSimplified: 6,
      warningSimplified: 0,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220009012300005',
      date: '2026-01-17',
      acceptedVat: 3,
      warningVat: 0,
      rejectedVat: 0,
      acceptedSimplified: 2,
      warningSimplified: 1,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220015067800011',
      date: '2026-01-16',
      acceptedVat: 15,
      warningVat: 3,
      rejectedVat: 2,
      acceptedSimplified: 8,
      warningSimplified: 0,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220003021700002',
      date: '2026-01-15',
      acceptedVat: 7,
      warningVat: 1,
      rejectedVat: 0,
      acceptedSimplified: 5,
      warningSimplified: 2,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220007019800002',
      date: '2026-01-14',
      acceptedVat: 10,
      warningVat: 0,
      rejectedVat: 1,
      acceptedSimplified: 7,
      warningSimplified: 0,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220012045600008',
      date: '2026-01-13',
      acceptedVat: 4,
      warningVat: 2,
      rejectedVat: 0,
      acceptedSimplified: 3,
      warningSimplified: 1,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220009012300005',
      date: '2026-01-12',
      acceptedVat: 9,
      warningVat: 1,
      rejectedVat: 1,
      acceptedSimplified: 4,
      warningSimplified: 0,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220015067800011',
      date: '2026-01-11',
      acceptedVat: 6,
      warningVat: 0,
      rejectedVat: 0,
      acceptedSimplified: 2,
      warningSimplified: 0,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220003021700002',
      date: '2026-01-10',
      acceptedVat: 11,
      warningVat: 2,
      rejectedVat: 1,
      acceptedSimplified: 9,
      warningSimplified: 1,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220007019800002',
      date: '2026-01-09',
      acceptedVat: 13,
      warningVat: 1,
      rejectedVat: 0,
      acceptedSimplified: 5,
      warningSimplified: 0,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220012045600008',
      date: '2026-01-08',
      acceptedVat: 2,
      warningVat: 0,
      rejectedVat: 0,
      acceptedSimplified: 1,
      warningSimplified: 0,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220009012300005',
      date: '2026-01-07',
      acceptedVat: 14,
      warningVat: 3,
      rejectedVat: 2,
      acceptedSimplified: 10,
      warningSimplified: 2,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220015067800011',
      date: '2026-01-06',
      acceptedVat: 8,
      warningVat: 1,
      rejectedVat: 1,
      acceptedSimplified: 6,
      warningSimplified: 0,
      rejectedSimplified: 0,
    },
  ],
});

export const invoiceViewPurchases = () => ({
  status: 200,
  data: [
    {
      vatNumber: '220008034500003',
      numberOfInvoices: 5,
      grossTotalAmount: 1575.0,
      vatAmount: 75.0,
      netAmount: 1500.0,
      date: '2026-01-20',
    },
    {
      vatNumber: '220011056700006',
      numberOfInvoices: 8,
      grossTotalAmount: 2625.0,
      vatAmount: 125.0,
      netAmount: 2500.0,
      date: '2026-01-19',
    },
    {
      vatNumber: '220008034500003',
      numberOfInvoices: 3,
      grossTotalAmount: 787.5,
      vatAmount: 37.5,
      netAmount: 750.0,
      date: '2026-01-18',
    },
    {
      vatNumber: '220014078900009',
      numberOfInvoices: 12,
      grossTotalAmount: 3150.0,
      vatAmount: 150.0,
      netAmount: 3000.0,
      date: '2026-01-17',
    },
    {
      vatNumber: '220011056700006',
      numberOfInvoices: 4,
      grossTotalAmount: 1050.0,
      vatAmount: 50.0,
      netAmount: 1000.0,
      date: '2026-01-16',
    },
    {
      vatNumber: '220008034500003',
      numberOfInvoices: 9,
      grossTotalAmount: 2362.5,
      vatAmount: 112.5,
      netAmount: 2250.0,
      date: '2026-01-15',
    },
    {
      vatNumber: '220016089100012',
      numberOfInvoices: 6,
      grossTotalAmount: 1312.5,
      vatAmount: 62.5,
      netAmount: 1250.0,
      date: '2026-01-14',
    },
    {
      vatNumber: '220014078900009',
      numberOfInvoices: 15,
      grossTotalAmount: 3937.5,
      vatAmount: 187.5,
      netAmount: 3750.0,
      date: '2026-01-13',
    },
    {
      vatNumber: '220008034500003',
      numberOfInvoices: 7,
      grossTotalAmount: 1837.5,
      vatAmount: 87.5,
      netAmount: 1750.0,
      date: '2026-01-12',
    },
    {
      vatNumber: '220011056700006',
      numberOfInvoices: 11,
      grossTotalAmount: 2887.5,
      vatAmount: 137.5,
      netAmount: 2750.0,
      date: '2026-01-11',
    },
    {
      vatNumber: '220016089100012',
      numberOfInvoices: 2,
      grossTotalAmount: 525.0,
      vatAmount: 25.0,
      netAmount: 500.0,
      date: '2026-01-10',
    },
    {
      vatNumber: '220014078900009',
      numberOfInvoices: 10,
      grossTotalAmount: 2100.0,
      vatAmount: 100.0,
      netAmount: 2000.0,
      date: '2026-01-09',
    },
    {
      vatNumber: '220008034500003',
      numberOfInvoices: 4,
      grossTotalAmount: 1312.5,
      vatAmount: 62.5,
      netAmount: 1250.0,
      date: '2026-01-08',
    },
    {
      vatNumber: '220011056700006',
      numberOfInvoices: 13,
      grossTotalAmount: 4725.0,
      vatAmount: 225.0,
      netAmount: 4500.0,
      date: '2026-01-07',
    },
    {
      vatNumber: '220016089100012',
      numberOfInvoices: 6,
      grossTotalAmount: 1575.0,
      vatAmount: 75.0,
      netAmount: 1500.0,
      date: '2026-01-06',
    },
  ],
});

export const invoiceViewPurchasesCounts = () => ({
  status: 200,
  data: [
    {
      vatNumber: '220008034500003',
      date: '2026-01-20',
      acceptedVat: 7,
      warningVat: 2,
      rejectedVat: 1,
      acceptedSimplified: 4,
      warningSimplified: 1,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220011056700006',
      date: '2026-01-19',
      acceptedVat: 10,
      warningVat: 1,
      rejectedVat: 0,
      acceptedSimplified: 6,
      warningSimplified: 0,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220016089100012',
      date: '2026-01-18',
      acceptedVat: 15,
      warningVat: 3,
      rejectedVat: 2,
      acceptedSimplified: 8,
      warningSimplified: 1,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220014078900009',
      date: '2026-01-17',
      acceptedVat: 5,
      warningVat: 1,
      rejectedVat: 0,
      acceptedSimplified: 3,
      warningSimplified: 0,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220008034500003',
      date: '2026-01-16',
      acceptedVat: 18,
      warningVat: 4,
      rejectedVat: 1,
      acceptedSimplified: 10,
      warningSimplified: 2,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220011056700006',
      date: '2026-01-15',
      acceptedVat: 9,
      warningVat: 2,
      rejectedVat: 1,
      acceptedSimplified: 7,
      warningSimplified: 1,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220016089100012',
      date: '2026-01-14',
      acceptedVat: 12,
      warningVat: 1,
      rejectedVat: 0,
      acceptedSimplified: 9,
      warningSimplified: 0,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220014078900009',
      date: '2026-01-13',
      acceptedVat: 6,
      warningVat: 3,
      rejectedVat: 1,
      acceptedSimplified: 4,
      warningSimplified: 2,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220008034500003',
      date: '2026-01-12',
      acceptedVat: 11,
      warningVat: 2,
      rejectedVat: 2,
      acceptedSimplified: 5,
      warningSimplified: 1,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220011056700006',
      date: '2026-01-11',
      acceptedVat: 8,
      warningVat: 0,
      rejectedVat: 0,
      acceptedSimplified: 3,
      warningSimplified: 0,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220016089100012',
      date: '2026-01-10',
      acceptedVat: 14,
      warningVat: 3,
      rejectedVat: 1,
      acceptedSimplified: 11,
      warningSimplified: 2,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220014078900009',
      date: '2026-01-09',
      acceptedVat: 16,
      warningVat: 2,
      rejectedVat: 1,
      acceptedSimplified: 7,
      warningSimplified: 1,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220008034500003',
      date: '2026-01-08',
      acceptedVat: 3,
      warningVat: 1,
      rejectedVat: 0,
      acceptedSimplified: 2,
      warningSimplified: 0,
      rejectedSimplified: 0,
    },
    {
      vatNumber: '220011056700006',
      date: '2026-01-07',
      acceptedVat: 17,
      warningVat: 4,
      rejectedVat: 2,
      acceptedSimplified: 12,
      warningSimplified: 3,
      rejectedSimplified: 1,
    },
    {
      vatNumber: '220016089100012',
      date: '2026-01-06',
      acceptedVat: 10,
      warningVat: 2,
      rejectedVat: 1,
      acceptedSimplified: 8,
      warningSimplified: 1,
      rejectedSimplified: 0,
    },
  ],
});

export const invoiceViewInvoiceList = () => ({
  status: 200,
  data: [
    {
      invoiceHash: 'HASH_THIRD_001',
      invoiceNumber: 'T-001',
      generatedBy: 'SYSTEM',
      sellerVat: '220003021700002',
      sellerName: 'ABC Trading Co.',
      buyerVat: '220007019800003',
      buyerName: 'XYZ Corporation',
      issueDate: 1737417600.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: null,
      currencyCode: 'BHD',
      netAmount: 1250.0,
      vatAmount: 62.5,
      grossAmount: 1312.5,
      thirdPartyVat: 'VAT789012',
      invoiceAcceptanceType: 'ACCEPTED',
      uuid: 'a1b2c3d4-e5f6-7890-abcd-1234567890ab',
    },
    {
      invoiceHash: 'HASH_THIRD_002',
      invoiceNumber: 'T-002',
      generatedBy: 'SYSTEM',
      sellerVat: 'vat123',
      sellerName: 'Seller Y',
      buyerVat: '220007019800003',
      buyerName: 'Buyer Y',
      issueDate: 1736680500.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: null,
      currencyCode: 'EUR',
      netAmount: 800.0,
      vatAmount: 152.0,
      grossAmount: 952.0,
      thirdPartyVat: 'VAT123456',
      invoiceAcceptanceType: null,
      uuid: 'caa3e297-73e7-4836-b71a-1f0c25c5113b',
    },
    {
      invoiceHash: 'HASH_THIRD_003',
      invoiceNumber: 'T-003',
      generatedBy: 'USER',
      sellerVat: '220009012300005',
      sellerName: 'Global Services Ltd',
      buyerVat: '220012045600008',
      buyerName: 'Tech Solutions Inc',
      issueDate: 1737331200.0,
      invoiceType: 'SIMPLIFIED',
      invoiceSubtype: 'B2C',
      specialScenario: null,
      currencyCode: 'BHD',
      netAmount: 450.0,
      vatAmount: 22.5,
      grossAmount: 472.5,
      thirdPartyVat: 'VAT345678',
      invoiceAcceptanceType: 'ACCEPTED',
      uuid: 'b2c3d4e5-f6a7-8901-bcde-234567890abc',
    },
    {
      invoiceHash: 'HASH_THIRD_004',
      invoiceNumber: 'T-004',
      generatedBy: 'SYSTEM',
      sellerVat: '220015067800011',
      sellerName: 'Prime Enterprises',
      buyerVat: '220008034500003',
      buyerName: 'Beta Corporation',
      issueDate: 1737244800.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: null,
      currencyCode: 'USD',
      netAmount: 2100.0,
      vatAmount: 105.0,
      grossAmount: 2205.0,
      thirdPartyVat: 'VAT567890',
      invoiceAcceptanceType: 'REJECTED',
      uuid: 'c3d4e5f6-a7b8-9012-cdef-34567890abcd',
    },
    {
      invoiceHash: 'HASH_THIRD_005',
      invoiceNumber: 'T-005',
      generatedBy: 'USER',
      sellerVat: '220011056700006',
      sellerName: 'Delta Manufacturing',
      buyerVat: '220016089100012',
      buyerName: 'Omega Retail',
      issueDate: 1737158400.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: 'EXPORTS',
      currencyCode: 'BHD',
      netAmount: 3500.0,
      vatAmount: 175.0,
      grossAmount: 3675.0,
      thirdPartyVat: 'VAT901234',
      invoiceAcceptanceType: 'ACCEPTED',
      uuid: 'd4e5f6a7-b8c9-0123-def0-4567890abcde',
    },
    {
      invoiceHash: 'HASH_THIRD_006',
      invoiceNumber: 'T-006',
      generatedBy: 'SYSTEM',
      sellerVat: '220014078900009',
      sellerName: 'Gamma Industries',
      buyerVat: '220003021700002',
      buyerName: 'Alpha Partners',
      issueDate: 1737072000.0,
      invoiceType: 'SIMPLIFIED',
      invoiceSubtype: 'B2C',
      specialScenario: null,
      currencyCode: 'BHD',
      netAmount: 675.0,
      vatAmount: 33.75,
      grossAmount: 708.75,
      thirdPartyVat: 'VAT234567',
      invoiceAcceptanceType: 'ACCEPTED',
      uuid: 'e5f6a7b8-c9d0-1234-ef01-567890abcdef',
    },
    {
      invoiceHash: 'HASH_THIRD_007',
      invoiceNumber: 'T-007',
      generatedBy: 'USER',
      sellerVat: '220007019800002',
      sellerName: 'Epsilon Trading',
      buyerVat: '220009012300005',
      buyerName: 'Zeta Logistics',
      issueDate: 1736985600.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: null,
      currencyCode: 'EUR',
      netAmount: 1800.0,
      vatAmount: 342.0,
      grossAmount: 2142.0,
      thirdPartyVat: 'VAT456789',
      invoiceAcceptanceType: 'PENDING',
      uuid: 'f6a7b8c9-d0e1-2345-f012-67890abcdef0',
    },
    {
      invoiceHash: 'HASH_THIRD_008',
      invoiceNumber: 'T-008',
      generatedBy: 'SYSTEM',
      sellerVat: '220012045600008',
      sellerName: 'Theta Supplies',
      buyerVat: '220015067800011',
      buyerName: 'Kappa Distribution',
      issueDate: 1736899200.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: null,
      currencyCode: 'BHD',
      netAmount: 950.0,
      vatAmount: 47.5,
      grossAmount: 997.5,
      thirdPartyVat: 'VAT678901',
      invoiceAcceptanceType: 'ACCEPTED',
      uuid: 'a7b8c9d0-e1f2-3456-0123-7890abcdef01',
    },
    {
      invoiceHash: 'HASH_THIRD_009',
      invoiceNumber: 'T-009',
      generatedBy: 'USER',
      sellerVat: '220016089100012',
      sellerName: 'Iota Services',
      buyerVat: '220014078900009',
      buyerName: 'Lambda Group',
      issueDate: 1736812800.0,
      invoiceType: 'SIMPLIFIED',
      invoiceSubtype: 'B2C',
      specialScenario: null,
      currencyCode: 'USD',
      netAmount: 325.0,
      vatAmount: 16.25,
      grossAmount: 341.25,
      thirdPartyVat: 'VAT890123',
      invoiceAcceptanceType: 'REJECTED',
      uuid: 'b8c9d0e1-f2a3-4567-1234-890abcdef012',
    },
    {
      invoiceHash: 'HASH_THIRD_010',
      invoiceNumber: 'T-010',
      generatedBy: 'SYSTEM',
      sellerVat: '220008034500003',
      sellerName: 'Mu Technologies',
      buyerVat: '220011056700006',
      buyerName: 'Nu Ventures',
      issueDate: 1736726400.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: 'NOMINAL',
      currencyCode: 'BHD',
      netAmount: 4200.0,
      vatAmount: 210.0,
      grossAmount: 4410.0,
      thirdPartyVat: 'VAT012345',
      invoiceAcceptanceType: 'ACCEPTED',
      uuid: 'c9d0e1f2-a3b4-5678-2345-90abcdef0123',
    },
    {
      invoiceHash: 'HASH_THIRD_011',
      invoiceNumber: 'T-011',
      generatedBy: 'USER',
      sellerVat: '220003021700002',
      sellerName: 'Xi Solutions',
      buyerVat: '220007019800002',
      buyerName: 'Omicron Ltd',
      issueDate: 1736640000.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: null,
      currencyCode: 'BHD',
      netAmount: 1575.0,
      vatAmount: 78.75,
      grossAmount: 1653.75,
      thirdPartyVat: 'VAT135790',
      invoiceAcceptanceType: 'PENDING',
      uuid: 'd0e1f2a3-b4c5-6789-3456-0abcdef01234',
    },
    {
      invoiceHash: 'HASH_THIRD_012',
      invoiceNumber: 'T-012',
      generatedBy: 'SYSTEM',
      sellerVat: '220009012300005',
      sellerName: 'Pi Commerce',
      buyerVat: '220012045600008',
      buyerName: 'Rho Enterprises',
      issueDate: 1736553600.0,
      invoiceType: 'SIMPLIFIED',
      invoiceSubtype: 'B2C',
      specialScenario: null,
      currencyCode: 'EUR',
      netAmount: 580.0,
      vatAmount: 110.2,
      grossAmount: 690.2,
      thirdPartyVat: 'VAT246801',
      invoiceAcceptanceType: 'ACCEPTED',
      uuid: 'e1f2a3b4-c5d6-7890-4567-1abcdef01234',
    },
    {
      invoiceHash: 'HASH_THIRD_013',
      invoiceNumber: 'T-013',
      generatedBy: 'USER',
      sellerVat: '220015067800011',
      sellerName: 'Sigma Logistics',
      buyerVat: '220008034500003',
      buyerName: 'Tau Holdings',
      issueDate: 1736467200.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: null,
      currencyCode: 'BHD',
      netAmount: 2850.0,
      vatAmount: 142.5,
      grossAmount: 2992.5,
      thirdPartyVat: 'VAT357912',
      invoiceAcceptanceType: 'ACCEPTED',
      uuid: 'f2a3b4c5-d6e7-8901-5678-2abcdef01234',
    },
    {
      invoiceHash: 'HASH_THIRD_014',
      invoiceNumber: 'T-014',
      generatedBy: 'SYSTEM',
      sellerVat: '220011056700006',
      sellerName: 'Upsilon Trade',
      buyerVat: '220016089100012',
      buyerName: 'Phi Industries',
      issueDate: 1736380800.0,
      invoiceType: 'STANDARD',
      invoiceSubtype: 'B2B',
      specialScenario: null,
      currencyCode: 'USD',
      netAmount: 1920.0,
      vatAmount: 96.0,
      grossAmount: 2016.0,
      thirdPartyVat: 'VAT468023',
      invoiceAcceptanceType: 'REJECTED',
      uuid: 'a3b4c5d6-e7f8-9012-6789-3abcdef01234',
    },
    {
      invoiceHash: 'HASH_THIRD_015',
      invoiceNumber: 'T-015',
      generatedBy: 'USER',
      sellerVat: '220014078900009',
      sellerName: 'Chi Partners',
      buyerVat: '220003021700002',
      buyerName: 'Psi Corporation',
      issueDate: 1736294400.0,
      invoiceType: 'SIMPLIFIED',
      invoiceSubtype: 'B2C',
      specialScenario: null,
      currencyCode: 'BHD',
      netAmount: 410.0,
      vatAmount: 20.5,
      grossAmount: 430.5,
      thirdPartyVat: 'VAT579134',
      invoiceAcceptanceType: 'ACCEPTED',
      uuid: 'b4c5d6e7-f8a9-0123-7890-4abcdef01234',
    },
  ],
});

export const invoiceViewThirdpartyStats = () => ({
  status: 200,
  data: {
    activeThirdParty: 4,
    numberOfInvoicesIssued: 138,
  },
});

export const invoiceViewThirdpartyCounts = () => ({
  status: 200,
  data: [
    {
      vatNumber: '220003016900002',
      date: '2026-02-08',
      acceptedVat: 121,
      warningVat: 11,
      rejectedVat: 12,
      acceptedSimplified: 10,
      warningSimplified: 110,
      rejectedSimplified: 121,
    },
    {
      vatNumber: '220003016900002',
      date: '2026-02-07',
      acceptedVat: 95,
      warningVat: 8,
      rejectedVat: 7,
      acceptedSimplified: 12,
      warningSimplified: 90,
      rejectedSimplified: 105,
    },
    {
      vatNumber: '220003016900002',
      date: '2026-02-06',
      acceptedVat: 110,
      warningVat: 15,
      rejectedVat: 9,
      acceptedSimplified: 8,
      warningSimplified: 95,
      rejectedSimplified: 115,
    },
  ],
});

export const getStatementStatusMock = () => {
  const statuses = [null, 'IN_PROGRESS', 'READY', 'FAILED', 'COMPLETED'];
  const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];

  return {
    status: 200,
    data: {
      status: randomStatus,
      downloadLink:
        randomStatus === 'READY' || randomStatus === 'COMPLETED'
          ? 'https://example.com/download/statement.pdf'
          : null,
    },
  };
};

export const invoiceViewThirdparty = () => ({
  status: 200,
  data: [
    {
      date: '2026-01-20',
      vatInvoices: 5,
      simplifiedInvoices: 3,
      agreement: 'ABC Trading Company',
    },
    {
      date: '2026-01-20',
      vatInvoices: 8,
      simplifiedInvoices: 4,
      agreement: 'XYZ Manufacturing Ltd',
    },
    {
      date: '2026-01-19',
      vatInvoices: 3,
      simplifiedInvoices: 2,
      agreement: 'ABC Trading Company',
    },
    {
      date: '2026-01-19',
      vatInvoices: 12,
      simplifiedInvoices: 6,
      agreement: 'Global Enterprises',
    },
    {
      date: '2026-01-18',
      vatInvoices: 4,
      simplifiedInvoices: 2,
      agreement: 'XYZ Manufacturing Ltd',
    },
    {
      date: '2026-01-18',
      vatInvoices: 9,
      simplifiedInvoices: 5,
      agreement: 'Tech Solutions Inc',
    },
    {
      date: '2026-01-17',
      vatInvoices: 6,
      simplifiedInvoices: 3,
      agreement: 'ABC Trading Company',
    },
    {
      date: '2026-01-17',
      vatInvoices: 15,
      simplifiedInvoices: 7,
      agreement: 'Global Enterprises',
    },
    {
      date: '2026-01-16',
      vatInvoices: 7,
      simplifiedInvoices: 4,
      agreement: 'XYZ Manufacturing Ltd',
    },
    {
      date: '2026-01-16',
      vatInvoices: 11,
      simplifiedInvoices: 6,
      agreement: 'Tech Solutions Inc',
    },
    {
      date: '2026-01-15',
      vatInvoices: 2,
      simplifiedInvoices: 1,
      agreement: 'ABC Trading Company',
    },
    {
      date: '2026-01-15',
      vatInvoices: 10,
      simplifiedInvoices: 5,
      agreement: 'Global Enterprises',
    },
    {
      date: '2026-01-14',
      vatInvoices: 4,
      simplifiedInvoices: 3,
      agreement: 'XYZ Manufacturing Ltd',
    },
    {
      date: '2026-01-14',
      vatInvoices: 13,
      simplifiedInvoices: 8,
      agreement: 'Tech Solutions Inc',
    },
    {
      date: '2026-01-13',
      vatInvoices: 6,
      simplifiedInvoices: 4,
      agreement: 'ABC Trading Company',
    },
    {
      date: '2026-01-13',
      vatInvoices: 9,
      simplifiedInvoices: 5,
      agreement: 'Global Enterprises',
    },
  ],
});
